import Request from '../utils/request';
const commonPath = '/landTransportApi/owner/app'; // 货主
const cargoApi = '/cargoApi/app' // 常用地址

// 获取货主认证信息
export async function getShipperPartyAuthInfo(params) {
  let url = `${commonPath}/truckBrokerShipper/getShipperPartyAuthInfo`;
  return Request(url, {
    method: 'GET',
    headers: {
      version: '2.0'
    },
    body: {
      ...params,
    },
  });
}

//获取当前登录会员信息
export async function getShipperPartyInfo(params) {
  let url = `${commonPath}/shipperBase/getAppPartyUserInfoByPartyId`;
  return Request(url, {
    method: 'GET',
    headers: {
      version: '2.0'
    },
    body: {
      ...params,
    },
  });
}

// 常用地址列表
export async function getAddressList(params){
  let url = `${cargoApi}/address/list`;
  return Request(url, {
    method: 'GET',
    headers: {
      version: '2.0'
    },
    body: {
      ...params,
    },
  });
}

// 查询已签署合同数
export async function selectContractCount(params) {
  let url = `${commonPath}/truckBrokerAgreement/selectContractCount`;
  return Request(url, {
    method: 'GET',
    headers: {
      version: '2.0'
    },
    body: {
      ...params,
    },
  });
}

// 图片信息-查询上传回单数
export async function selectReceiptCount(params) {
  let url = `${commonPath}/truckBrokerAgreement/selectReceiptCount`;
  return Request(url, {
    method: 'GET',
    headers: {
      version: '2.0'
    },
    body: {
      ...params,
    },
  });
}

// 位置信息-查询订单数
export async function selectOrderCount(params) {
  let url = `${commonPath}/truckBrokerAgreement/selectOrderCount`;
  return Request(url, {
    method: 'GET',
    headers: {
      version: '2.0'
    },
    body: {
      ...params,
    },
  });
}


// WEBPACK FOOTER //
// ./src/services/personalInfo.js